import React from 'react';
const findByType = (children, type) => {
  let found = null;
  React.Children.forEach(children, child => {
    if (found) return;
    if (! /*#__PURE__*/React.isValidElement(child)) return;
    if (child.type === type) {
      found = child;
      return;
    }
    if (child.props?.children) {
      found = findByType(child.props.children, type);
    }
  });
  return found;
};
export default findByType;
//# sourceMappingURL=find-by-type.js.map